import React from 'react'
import {
  Box,
  Text,
  Button,
  HStack,
  VStack,
  useDisclosure,
} from '@chakra-ui/react'
import TermsOfServiceModal from './TermsOfServiceModal'
import { CURRENT_TOS_VERSION, CURRENT_PRIVACY_VERSION } from '../../config/legalVersions'

interface ToSUpdateBannerProps {
  isVisible: boolean
  onAccept?: () => void
  userVersion?: string
}

export const ToSUpdateBanner: React.FC<ToSUpdateBannerProps> = ({
  isVisible,
  onAccept,
  userVersion,
}) => {
  const { open: isOpen, onOpen, onClose } = useDisclosure()

  const handleAccept = () => {
    onAccept?.()
    onClose()
  }

  if (!isVisible) {
    return null
  }

  return (
    <>
      <Box
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        zIndex="banner"
        bg="blue.50"
        borderTop="1px"
        borderColor="blue.200"
        p={4}
        pb={{ base: "calc(1rem + env(safe-area-inset-bottom))", md: 4 }}
        shadow="sm"
      >
        <HStack justify="space-between" align="center" maxW="6xl" mx="auto">
          <VStack align="start" gap={1} flex={1}>
            <Text fontWeight="semibold" fontSize="sm">
              We&apos;ve updated our Terms of Service and Privacy Policy
            </Text>
            <Text fontSize="xs" color="gray.600">
              Terms v{CURRENT_TOS_VERSION} and Privacy v{CURRENT_PRIVACY_VERSION} are now in effect.
              {userVersion && ` You last accepted Terms v${userVersion}.`}
            </Text>
          </VStack>

          <HStack gap={3}>
            <Button size="sm" variant="outline" colorScheme="blue" onClick={onOpen}>
              Review
            </Button>
            <Button size="sm" colorScheme="blue" onClick={handleAccept}>
              Accept
            </Button>
          </HStack>
        </HStack>
      </Box>

      <TermsOfServiceModal
        isOpen={isOpen}
        onClose={onClose}
        onAccept={handleAccept}
        showAcceptDecline
        title="Updated Terms of Service & Privacy Policy"
        acceptText="Accept updated terms"
        declineText="Close"
      />
    </>
  )
}

export default ToSUpdateBanner
